import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Flatten the positioned tree into one translated SVG group per node.
 * @param nodes - Positioned nodes, each carrying its `position` and rendered `element`.
 * @param options - May provide `getID` to stamp an id on each group.
 * @returns One `<g>` element per node, moved to the node's computed coordinates.
 */
export function getBoxes(nodes, options) {
    const boxes = [];
    appendBoxes(nodes, boxes, options);
    return boxes;
}
function appendBoxes(nodes, boxes, options = {}) {
    const { getID } = options;
    for (const node of nodes) {
        boxes.push(_jsx("g", { id: getID ? getID(node) : undefined, transform: `translate(${node.position.x} ${node.position.y})`, children: node.element }, boxes.length));
        if (node.children) {
            appendBoxes(node.children, boxes, options);
        }
    }
}
//# sourceMappingURL=getBoxes.js.map